import React from "react";
import { withTranslation } from "react-i18next";
import { Button, Snackbar } from "@material-ui/core";
import MuiAlert from "@material-ui/lab/Alert";
import { setLoginError } from "../../utils/Functions/functions";
import UserInput from "../../components/UserInput/UserInput";
import history from "../../history";
import axios from "../../utils/Axios/axiosProxy";
import styles from "./UserEntry.module.scss";
import userInputStyle from "../../components/UserInput/UserInput.module.scss";
import i18n from "../../utils/LanguageSelector/i18n";
class UserSignIn extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      email: "",
      password: "",
      open: false,
      errorMessage: "",
    };
  }

  login = () => {
    let data = { email: this.state.email, password: this.state.password };
    axios
      .post("/api/user/login", JSON.stringify(data), {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        console.log("LOGIN RESPONSE: ", response.statusText);
        localStorage.setItem("JWT", response.data.JWT);
        history.push(`/dashboard`);
      })
      .catch((error) => {
        console.log("LOGIN ERROR: ", error.response.data.message);
        this.setState({
          open: true,
          errorMessage: setLoginError(error.response.data.message),
        });
      })
      .catch((error) => console.log("LOGIN DB ERROR:", error));
  };
  handleChange = (event) => {
    this.setState({ [event.target.id]: event.target.value });
  };
  handleClose = () => {
    this.setState({ open: false });
  };
  render() {
    const SignIn = [
      { label: i18n.t("general.email"), id: "email", type: "text" },
      { label: i18n.t("general.password"), id: "password", type: "password" },
    ];
    function Alert(props) {
      return <MuiAlert elevation={6} variant="filled" {...props} />;
    }
    return (
      <div className={styles.UserEntryContainer}>
        <Snackbar
          open={this.state.open}
          autoHideDuration={6000}
          onClose={this.handleClose}
          style={{ width: "100%" }}
        >
          <Alert
            onClose={this.handleClose}
            severity="error"
            className="AlertWidth"
          >
            {this.state.errorMessage}
          </Alert>
        </Snackbar>
        <div className={styles.UserEntryContent}>
          <h2 className={styles.UserEntryTitle}> {i18n.t("signin.signin")}</h2>
          <div className={`${styles.UserEntryInputs} FlexCenter Column`}>
            {SignIn.map((input) => {
              return (
                <UserInput
                  key={input.id}
                  name={input.label}
                  id={input.id}
                  type={input.type === "password" ? input.type : null}
                  className={userInputStyle.RegInput}
                  value={this.state[input.id]}
                  onChange={(event) => {
                    this.handleChange(event);
                  }}
                />
              );
            })}
            <div className={styles.UserEntryErrorMessageContainer}>
              <a href="/forgotpassword" className="OrangeFont Bold">
                {i18n.t("signin.forgotpw")}
              </a>
            </div>
            <div className={styles.UserEntryButton}>
              <Button
                onClick={() => {
                  if (
                    this.state.password.length > 0 &&
                    this.state.email.length > 0
                  ) {
                    this.login();
                  }
                }}
                className="ToreaBay Medium MarginHorizontal"
              >
                {i18n.t("signin.signin")}
              </Button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withTranslation()(UserSignIn);
